module.exports = __webpack_public_path__ + "img/rzetelnafirma.86095e9e.png";